<template>
  <div class="lanSet">
    <el-table :height="620" class="table-container" :data="adminList"
      @sort-change="sortChanged" :cell-class-name="addEnClass" :default-sort="{ prop: '', order: 'descending' }">
      <template slot="empty">
        <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
        <h4 class="common-table-noData" v-show="!loading">
          <img src="../../assets/images/v4_nodata.png" alt="" />
          <div class="noData-text">
            {{ $t("common.noData") }}
          </div>
        </h4>
      </template>
      <!--  序号 -->
      <el-table-column prop="sort" align="left" :label="$t('publicManage.lanset.sort')" width="150">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>

      </el-table-column>
      <!--  语言描述 -->
      <el-table-column prop="langName" align="right"  :label="$t('publicManage.basenav.language')">
      </el-table-column>
      <!-- 文件名 -->
      <el-table-column prop="fileName" align="right" :label="$t('publicManage.lanset.fileName')">
        <template slot-scope="scope">
          <span> {{ scope.row.langKey + ".json" }}</span>
        </template>
      </el-table-column>
      <!--  状态-->
      <el-table-column prop="desc" align="right" :label="$t('publicManage.lanset.status')">
        <template slot-scope="scope">
          <span :class="scope.row.status === 0 ? 'red' : 'green'">
            {{
      scope.row.status === 0
        ? $t("publicManage.lanset.pause")
        : $t("publicManage.lanset.startUse")
    }}
          </span>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column prop="action" :label="$t('common.find')" fixed="right" align="right">
        <template slot-scope="scope">
          <b-button size="sm" variant="outline-primary" @click="
      modify(
        scope.row.langKey,
        'admin',
        scope.row.nowFileAddress,
        scope.row.backupFileAddress
      )
      ">
            <!-- 编辑 -->
            {{ $t("common.editor") }}
          </b-button>
          <b-button size="sm" variant="outline-primary" @click="reset(scope.row.langKey, 'admin', scope.row.id)">
            <!-- 还原 -->
            {{ $t("publicManage.lanset.reset") }}
          </b-button>
          <b-button size="sm" :variant="scope.row.status ? 'outline-primary' : 'outline-primary'" :disabled="scope.row.langKey === 'en_US' || scope.row.langKey === language
      " @click="handleSwitch(scope.row, 6)">
            <!-- 启用/停用 -->
            {{
      setItem(scope.row).status === 0
        ? $t("publicManage.lanset.startUse")
        : $t("publicManage.lanset.pause")
    }}
          </b-button>

        </template>
      </el-table-column>
    </el-table>
    <b-modal v-model="statusFlag" :title="$t('publicManage.lanset.tip')" id="small-modal" size="lg" hide-header-close
      no-close-on-backdrop>
      <section>
        <p class="modal-titles">
          {{ $t("publicManage.lanset.statusTitle", { lang: activeRow.text }) }}
        </p>
        <p v-if="tabIndex !== 3" class="modal-text">
          {{ $t("publicManage.lanset.statusText") }}
        </p>
      </section>
      <section class="deilog-bottom" slot="modal-footer">
        <!-- 取消 -->
        <b-button class="coustom-btn" @click="switchCancel">
          {{ $t("publicManage.lanset.cancel") }}
        </b-button>
        <!-- 启用/停用 -->
        <b-button class="coustom-btn" variant="primary" @click="switchSubmit">
          <!-- {{ $t('publicManage.lanset.ok') }} -->
          {{
      activeRow.status === 0
        ? $t("publicManage.lanset.startUse")
          : $t("publicManage.lanset.pause")
          }}
        </b-button>
      </section>
    </b-modal>
  </div>
</template>

<script>
import commonMixin from "@/mixin/common/commonMixin";
export default {
  name: "languageService",
  components: {},
  mixins: [commonMixin],
  data() {
    return {
      tabIndex: 0,
      notData: false,
      loading: false,
      isOpen: null,
      isOpenType: [],
      webDataList: [],
      appDataList: [],
      serverList: [],
      adminList: [],
      num: 0,
      fileUrl: null,
      uploadType: null,
      uploadLan: null,
      secoundClick: true,
      altersImg: require("@/assets/images/alerts.png"),
      aa: null,
      bb: null,
      addLanguageFlag: false,
      modalDisabled: false,
      statusFlag: false,
      activeRow: {
        text: "简体中文",
        type: "web",
        status: 0,
      },
    };
  },
  computed: {
    language() {
      return this.$store.state.baseData.language;
    },
    url() {
      return this.$store.state.url.imgUpload;
    },
  },
  mounted() {
    // this.getLang();
    this.getDownloadAddress();
  },
  methods: {
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "value":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
    },
    setItem(v) {
      if (v.value === "zh_CN" || v.value === "en_US") {
        const ar = JSON.parse(JSON.stringify(v));
        ar.status = 1;
        return ar;
      }
      return v;
    },
    // 获取语言列表
    // getLang() {
    //   this.$http({
    //     url: "company_lang_list",
    //   }).then((data) => {
    //     if (data.code.toString() === "0") {
    //       // console.log(JSON.parse(data.data.repository.content.text))
    //       this.isOpenType = [];
    //       data.data.list.map((item) => {
    //         if (item.status === 0) {
    //           this.isOpenType.push({ text: item.text, value: item.value });
    //         }
    //       });
    //       this.isOpen = this.isOpenType[0].value;
    //       this.addText = this.isOpenType[0].text;
    //       // console.log(this.isOpen, "isOpen");
    //     } else {
    //       this.$bus.$emit("alert", { type: "error", message: data.msg });
    //     }
    //   });
    // },
    // 开启语言
    addLan() {
      if (!this.secoundClick) return;
      this.secoundClick = false;
      this.addLanguageFlag = true;
    },
    langSure() {
      this.$http({
        url: "company_lang_add",
        params: {
          lang: this.isOpen,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          console.log(data);
          // this.getLang();
          this.getDownloadAddress();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
        this.secoundClick = true;
        this.addLanguageFlag = false;
      });
    },
    langCancel() {
      this.secoundClick = true;
      this.addLanguageFlag = false;
    },
    // 获取下载地址
    getDownloadAddress() {
      this.loading = true;
      this.$http({
        url: "language/langStatuList",
        params: {
          type: 6, //服务端 5:管理后台6
        },
      }).then((data) => {
        this.loading = false;
        if (data.code.toString() === "0") {
          let arr1 = [];
          let arr2 = [];
          data.data.langStatuList.forEach((item) => {
            if (item.status == 1) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          arr1 = arr1.reverse();
          arr1 = arr1.concat(arr2);
          this.adminList = arr1;
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 还原
    // upload(lang,type,address){
    //   let status = type === 'web' ? 1 : 2
    //   this.$http({
    //     url: 'company_lang_cloud_address_update',
    //     params: {
    //       lang: lang,
    //       type: status,
    //       address: address,
    //     }
    //     }).then((data) => {
    //     if (data.code.toString() === '0') {
    //       console.log(data)
    //       // this.getLang()
    //       this.getDownloadAddress()
    //     } else {
    //       this.$bus.$emit('alert', {type: 'error', message: data.msg})
    //     }
    //   })
    // },
    modify(lan, type, address, backupAddress) {
      this.$router.push({
        path: "languageModify",
        query: { lan, type, address, backupAddress },
      });
    },
    reset(langKey, type, id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("publicManage.lanset.resetNote"), {
          title: this.$t("common.tip"),
          size: "md",
          buttonSize: "md",
          okTitle: this.$t("publicManage.lanset.ok"),
          cancelTitle: this.$t("publicManage.lanset.cancel"),
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            const paramsData = {
              langKey,
              type: 6,
              id,
            };
            this.$http({
              url: "language/langFileReduce",
              params: paramsData,
            }).then(({ code, data, msg }) => {
              if (code.toString() === "0") {
                this.getDownloadAddress();
                this.$bus.$emit("alert", { type: "success", message: msg }); // '操作成功'
                window.location.reload();
              } else {
                this.$bus.$emit("alert", { type: "error", message: msg });
              }
            });
          }
        })
        .catch((err) => { });
    },
    handleSwitch(row, type) {
      // console.log(row)
      this.activeRow = row;
      this.activeType = type;
      this.switchSubmit();
    },
    switchCancel() {
      this.statusFlag = false;
    },
    switchSubmit() {
      const { langKey, status } = this.activeRow;
      this.$http({
        url: "language/updateStatus",
        params: {
          langKey: langKey,
          status: status === 0 ? 1 : 0,
          type: this.activeType,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          this.getDownloadAddress();
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "success", message: data.msg });
          window.location.reload();
        } else {
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.basenav {
  .header {
    font-size: 15px;
  }

  .nav-tabs li {
    margin-right: 10px;
  }

  .nav-tabs .nav-link.active {
    cursor: default;
  }
}

.lanSet {
  .card {
    border-radius: 8px !important;
  }

  .lanList {
    width: 200px;
    float: left;
    margin-right: 40px;
  }

  button {
    margin-right: 10px;
  }

  .input-hide {
    display: none;
  }

  .note {
    margin-top: 15px;
    color: var(--theme-color-red);

    img {
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }
  }
}

.modal-titles {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
}

.red {
  color: var(--theme-color-red);
}

.green {
  color: var(--theme-color-green);
}
</style>
